import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { sendErrorAnalyticsData } from '../../../services/analytics';
import { buildErrorAnalyticsData } from '../../../utils';
import { SERVER_ERROR } from '../../../constants/routeTemplates';
import { getHistoryPathList } from '../../../services/historyPathList';

export const ERRORS_TO_IGNORE = {
  FAILED_TO_REMOVE_NODE: "Failed to execute 'removeChild' on 'Node'",
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    if (error.toString().includes(ERRORS_TO_IGNORE.FAILED_TO_REMOVE_NODE)) {
      return {};
    }

    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error);

    sendErrorAnalyticsData(
      buildErrorAnalyticsData(
        {
          source: 'ErrorBoundary Redirect componentDidCatch',
          error,
          errorInfo: JSON.stringify(errorInfo).substring(0, 768),
          pathname: SERVER_ERROR,
          historyPathList: getHistoryPathList(),
        },
        error
      )
    );

    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    const { hasError, error } = this.state;
    if (hasError) {
      return <Redirect to={{ pathname: SERVER_ERROR, state: { error } }} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
